const storageKeys = {
  APP_TOKEN: 'uid',
  REFRESH_TOKEN: 'rfid',
  TOKEN_EXPIRY: 'finish',
  PDF_JOBS: 'edpodia_pdf_jobs',
};

const DEFAULT_COLOURS = { primary: '#000000', secondary: '#000000' };

const LIMIT = 20;
const INITIAL_PAGE = 0;

const ADMIN = 'ADMIN';
const STUDENT = 'STUDENT';
const TUTOR = 'TUTOR';
const CONTENT_CREATOR = 'CONTENT_CREATOR';
const QC = 'QC';
const MODERATOR = 'MODERATOR';
const SUBJECT_EXPERT = 'SUBJECT_EXPERT';

const COMMENT_IDENTIFIER = '__COMMENT_IDENTIFIER__';

const ROLES = { ADMIN, CONTENT_CREATOR, STUDENT, TUTOR, QC, MODERATOR, SUBJECT_EXPERT };

const contentErrors = {
  plagiarism: 'Plagiarism',
  factual_error: 'Factual error',
  language_quality: 'Language quality',
  add_part: 'Add part',
  irrelevant_part: 'Remove part',
  repetitive_part: 'Repetitive part',
  no_issues: 'No Issues [Content Verified]',
  other: 'Others',
  replace: 'Replace',
  formatting: 'Formatting',
};

const questionIssues = {
  question: 'Question',
  answer: 'Answer',
  explanation: 'Explanation',
  other: 'Others',
};

const countryShortCodes = { uk: 'uk', in: 'in' };

const underTutorReview = 'Tutor Vetting';
const underQcReview = 'QC Reviewing';
const underSeReview = 'SE Correcting';

const selectActionText = 'Select an Action';

const contentStatus = {
  review: 'Submit for SE Correction',
  qc_review: 'Submitted for QC review',
  teacher_review: 'Submitted for Tutor Vetting',
  teacher_verified: 'Marked as verified',
};

export { underSeReview, underTutorReview, underQcReview };
export { INITIAL_PAGE, LIMIT, ROLES, COMMENT_IDENTIFIER, countryShortCodes };
export {
  storageKeys,
  DEFAULT_COLOURS,
  contentErrors,
  questionIssues,
  selectActionText,
  contentStatus,
};
